import http from '@/http'

const PATH = '/cancellations'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listCancellations (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{cancellationId: number}} data
     * @returns {Promise<void>}
     */
    async showCancellation ({cancellationId}) {
        try {
            const response = await http.get(`${PATH}/${cancellationId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} data
     * @returns {Promise<void>}
     */
    async updateCancellation (data) {
        try {
            const response = await http.put(`${PATH}/${data.id}`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
